module.exports = __webpack_public_path__ + "img/imagen_parrafo_8.43638e02.jpg";